import * as React from "react";

import { ISpecies } from "../../api/models/ISpecies";
import { TManagerMode } from "../../types/TManagerMode";

interface ISpeciesContext {
  hydrating: string | boolean | null;
  mode: TManagerMode;
  setMode: (mode: TManagerMode) => void;
  species: ISpecies | null;
  setSpecies: (species: ISpecies) => void;
}

const SpeciesContext = React.createContext<ISpeciesContext | null>(null);

const useSpeciesContext = (): ISpeciesContext => {
  const ctx = React.useContext(SpeciesContext);
  if (!ctx) throw new Error('useSpeciesContext must be used inside a <SpeciesContext> provider.');
  return ctx;
}

export { ISpeciesContext, SpeciesContext, useSpeciesContext }
